import { render, staticRenderFns } from "./timedsalegoodsdetail.vue?vue&type=template&id=5ca3fb71&scoped=true&"
import script from "./timedsalegoodsdetail.vue?vue&type=script&lang=js&"
export * from "./timedsalegoodsdetail.vue?vue&type=script&lang=js&"
import style0 from "./timedsalegoodsdetail.vue?vue&type=style&index=0&id=5ca3fb71&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca3fb71",
  null
  
)

export default component.exports